import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import header from '../../../public/icons/about_header.png';
import divider from '../../../public/icons/about_divider.png';
import snapshot from '../../../public/icons/about_snapshot.png';
import style from './About.css';

class About extends React.Component {
  render() {
    const dividerElement = (
      <div className={style.dividerWrapper}>
        <img src={divider} />
      </div>
    );

    return (
      <div className="container-fluid">
        <div className={cx('row', style.rowContainer)}>
          <div className={style.headerImage}>
            <img src={header} />
          </div>
          <div className={style.quoteContainer}>
            <div className={style.quoteText}>
              “We must credit the child with enormous potential and the children
              must feel that trust. The teacher must give up all his
              preconceived notions and accept the child as a co-constructor.”
            </div>
            <div className={style.quoteName}>Loris Malaguzzi</div>
          </div>
          {dividerElement}
          <div className={style.whyWrapper}>
            <div className={style.whyText}>
              <p className={style.whyTitle}>WHY BITAA?</p>
              <p className={style.whyBody}>
                Bitaa is an activities resource developed at a childcare centre
                with over 25 years in the business of early childhood education.
                We follow the Reggio Emilia Approach, and it has translated to
                the Bitaa Daily Activity Book in the form of focusing all
                activities on the child as a capable and competent individual.
                We have piloted this resource in our centres and found that it
                is incredible adaptable to different age groups, environments,
                settings, and group sizes.
              </p>
              <p className={style.whyBody}>
                Whether you are working with four children or twenty-four grade
                school aged kids, this resource has something for any situation.
                The activities not only build on skills from the seven core
                developmental domains but also help to build a broader sense of
                confidence in the learning environment for students and
                educators alike.
              </p>
            </div>
            <div className={style.whyPicture}>
              <img src={snapshot} />
            </div>
          </div>
          {dividerElement}
          <div className={style.cardsContainer}>
            <div className={cx(style.cardOne, style.card)}>
              <div className={style.cardTitle}>
                WHY SHOULD I USE THIS APPLICATION?
              </div>
              <div className={style.cardBody}>
                <p>
                  In today’s world, people are inundated with information. That
                  goes for the realm of education as well. There are an infinite
                  number of books, programs, blogs, resources, and websites that
                  claim to have educational material. This app takes away the
                  work of searching through all these complex sources by
                  providing the educator or parent with hand picked activities
                  from a variety of locations.
                </p>
                <p>
                  Additionally, activities in this resource are minimalist.
                  There is no single set of rules for completing any activity,
                  only guidelines and suggestions, which makes this resource
                  incredibly flexible to individual skillsets and needs.
                </p>
              </div>
            </div>
            <div className={cx(style.cardTwo, style.card)}>
              <div className={style.cardTitle}>HOW DOES IT HELP MY CHILD?</div>
              <div className={style.cardBody}>
                <p>
                  This resource helps children construct who they are as a
                  learner. The activities provide opportunities for
                  self-expression in the education environment. The goal is to
                  help children develop confidence as learners, to see
                  themselves as capable and creative, and to understand that
                  they are able to direct their own learning experiences.
                </p>
                <p>
                  Due to the diversity of activities in this app, children are
                  also provided the opportunity to explore their own interests
                  and talents and discover what they like, what they are good
                  at, and how to build on those skills.
                </p>
              </div>
            </div>
            <div className={cx(style.cardThree, style.card)}>
              <div className={style.cardTitle}>
                BENEFITS FOR CAREGIVERS, EDUCATORS, AND PARENTS
              </div>
              <div className={style.cardBody}>
                <p>
                  This resource allows the educator to also explore their own
                  skills and approaches. Activities provide the user with the
                  peace of mind that they will always have something ready to
                  go. They may rest easy knowing that ideas or inspirations are
                  at their fingertips. This activity also allows for
                  self-reflection on the methodology used by parents,
                  caregivers, and educators. It allows for consideration of what
                  works well, and what needs improvement in order to produce the
                  best educational environment for children.
                </p>
                <p>
                  Additionally, this resource is incredibly dynamic. We are
                  constantly striving to improve the materials we provide by
                  adding the collection of activities, and testing out best
                  practices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(style)(About);



// WEBPACK FOOTER //
// ./src/routes/about/About.js